"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Philosophy() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: narrativeRef,
    isVisible: narrativeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3311" id="nasza-misja-i-doświadczenie" className="bg-background text-foreground py-24 md:py-40 lg:py-[200px] px-6 md:px-12 lg:px-20">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div className="font-default text-xs md:text-sm uppercase tracking-widest text-foreground mb-16 md:mb-24" style={{
        letterSpacing: "0.2em"
      }}>
          02 &mdash; FILOZOFIA
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div ref={titleRef} className={`lg:col-span-4 transition-all duration-1000 ease-out ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="lg:sticky lg:top-32">
              <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-foreground" style={{
              letterSpacing: "-0.04em"
            }}>
                Fundamenty
                <br />
                Naszej Pracy
              </h2>
              <div className="mt-6 flex items-center gap-3">
                <span className="block w-10 h-px bg-primary" />
                <p className="font-default italic text-sm md:text-base text-secondary">
                  BudSys, Śląsk 2025
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:col-start-6">
            <div ref={narrativeRef} className={`transition-all duration-1000 ease-out ${narrativeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {}
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                <span className="float-left font-default font-bold text-[80px] md:text-[96px] leading-[0.85] mr-3 mt-1 text-primary" style={{
                letterSpacing: "-0.04em"
              }}>
                  B
                </span>
                udSys powstał z przekonania, że budownictwo to nie tylko beton i stal, ale przede wszystkim zaufanie. Nasza firma wyrosła na śląskiej ziemi, gdzie solidność i terminowość są wartościami nadrzędnymi. Od pierwszego wykopu po finalne zagospodarowanie terenu, każdy etap inwestycji traktujemy z najwyższą precyzją inżynierską. Nie uznajemy dróg na skróty – budujemy obiekty, które mają służyć pokoleniom.
              </p>

              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Przez lata doskonaliliśmy nasze techniki, inwestując w nowoczesny park maszynowy i zespół wykwalifikowanych fachowców. Każdy projekt, od fundamentów po skomplikowane przyłącza, przechodzi przez rygorystyczną kontrolę jakości. Współpracujemy z najlepszymi dostawcami materiałów, aby zapewnić naszym klientom trwałość, której oczekują. Nasze doświadczenie to gwarancja spokoju inwestora na każdym etapie budowy.
              </p>

              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Profesjonalizm to dla nas nie tylko słowo, to dyscyplina. Rozumiemy, że budowa domu to jedna z najważniejszych decyzji w życiu naszych klientów. Dlatego stawiamy na pełną transparentność kosztów, jasne zasady współpracy i terminowość. Nie jesteśmy tylko wykonawcą – jesteśmy partnerem, który dba o każdy detal, od niwelacji terenu po estetyczne wykończenie kostką brukową.
              </p>
            </div>

            {}
            <div ref={quoteRef} className={`my-16 md:my-20 py-16 md:py-20 transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              <div className="h-px w-full bg-primary" />
              <blockquote className="font-default italic text-2xl md:text-3xl lg:text-[32px] text-center text-foreground py-12 md:py-16 px-4" style={{
              lineHeight: "1.4",
              letterSpacing: "-0.02em"
            }}>
                &ldquo;Budujemy solidnie, bo wiemy, że na fundamentach opiera się przyszłość.&rdquo;
              </blockquote>
              <div className="h-px w-full bg-primary" />
            </div>

            {}
            <div className={`transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-default text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                To, co nas wyróżnia, to kompleksowość. Zamiast szukać wielu podwykonawców, powierzasz nam cały proces – od przygotowania działki, przez instalacje podziemne, aż po małą architekturę ogrodową. Dzięki temu zyskujesz pewność, że wszystkie elementy inwestycji są ze sobą spójne i wykonane zgodnie z najwyższymi standardami budowlanymi.
              </p>
            </div>

            {}
            <div ref={imageRef} className={`mt-16 md:mt-20 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="relative w-full overflow-hidden rounded-lg shadow-lg" style={{
              aspectRatio: "21/9"
            }}>
                <img alt="Profesjonalne prace ziemne i wylewanie fundamentów na placu budowy" loading="lazy" decoding="async" className="w-full h-full object-cover" src="https://budsys.pl/wp-content/uploads/2026/07/b0ba077d06c6f7371731576f7f13fac0.jpg" />
              </div>
              <p className="font-default italic text-[13px] text-secondary mt-4">
                Realizacja fundamentów, województwo śląskie, 2025.
              </p>
            </div>

            {}
            <div className={`mt-12 transition-all duration-1000 ease-out delay-200 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-default text-[17px] md:text-[19px] text-foreground" style={{
              lineHeight: "1.75"
            }}>
                W BudSys wierzymy, że dom to coś więcej niż ściany. To miejsce, w którym zaczyna się życie. Dlatego z taką samą starannością podchodzimy do układania kostki brukowej na podjeździe, jak i do wznoszenia konstrukcji nośnej. Nasza praca to nasza wizytówka, a zadowolenie klientów na Śląsku jest dla nas najlepszą rekomendacją. Zapraszamy do współpracy – zbudujmy coś trwałego razem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}